import React from 'react';
import classnames from 'classnames';

import { Link } from 'gatsby';

import * as S from './Card.module.css';
import * as T from './Card.types';

export const Card: React.FunctionComponent<T.ICardProps> = ({
  className,
  link,
  text,
  target,
  icon,
  title,
  contacts,
  image,
  imgClassName,
  titleClassName,
  contactsClassName,
}) => {
  const cardClass = classnames(
    S.card,
    {
      [S.cardContacts]: !!contacts,
    },
    className
  );

  return (
    <Link className={cardClass} to={link} target={target}>
      {icon ? (
        <div className={S.cardIcon}>{icon}</div>
      ) : (
        image && (
          <div
            className={classnames(S.cardImage, imgClassName)}
            style={{ backgroundImage: `url(${image})` }}
          />
        )
      )}
      {title && (
        <h2 className={classnames(S.title, titleClassName)}>{title}</h2>
      )}
      {text}
      {contacts && (
        <div className={classnames(S.contactsTitle, contactsClassName)}>
          {contacts}
        </div>
      )}
    </Link>
  );
};
